import { useState } from "react";

export const useClipboard = () => {
    const [isCopied, setIsCopied] = useState(false);

    const handleCopy = async (text: string) => {
        try {
            const copy = (await import("copy-to-clipboard")).default;
            copy(text);

            setIsCopied(true);

            setTimeout(() => setIsCopied(false), 3000);
        } catch (_e) {}
    };

    return { isCopied, handleCopy };
};
